module.exports = __webpack_public_path__ + "img/1493194768.456d6b36.jpg";